/* REQ-023 (S5) · gift with purchase engine. Config: window.PMGWP (snippets/pm-gwp.liquid).
   Keeps exactly one gift line while the items (excluding the gift, before checkout codes) reach the threshold:
   adds it at the threshold, removes it below, sets it back to quantity 1, removes it if it is ever charged.
   G3-r2 (03.11): the gift is a ₪39 product made ₪0 by Shopify's automatic discount, so "charged" means the discount
   is not on the line: the engine removes it and stops for the session. Colour: the customer's choice in the cart
   (buttons [data-pm-gwp-color] in snippets/pm-gwp-line.liquid, kept in sessionStorage), else the default variant.
   A failed add is not a refusal: no gift text while it is failing, retry on a later cart change (after 60 s);
   a sold-out gift (HTTP 422) stops for this session. In cleanup mode (outside the window) it only removes gift lines. Publishes the state as window.PMGWPState + a 'pm:gwp' event,
   which the progress bar (snippets/pampas-cart-progress.liquid) renders. */
(function () {
  var C = window.PMGWP;
  if (!C || !(C.variant || (C.variants && C.variants.length))) return;
  var IDS = (C.variants && C.variants.length ? C.variants : [C.variant]).map(Number);
  // G3-r2 (Ran 03.11): the gift is the shop's real product "ואזה מעוגלת כולל פרחים", which customers can also buy.
  // Every line of that product stays out of the ₪250 sum (as in the discount's eligible collection), but only the line
  // this engine added (property _gwp) is the gift: a customer's own vases are never touched.
  function isProduct(i) { return IDS.indexOf(Number(i.variant_id)) !== -1; }
  function isGift(i) { return isProduct(i) && !!(i.properties && i.properties._gwp); }
  // free = the discount took one unit's price off the gift line itself (Codex 03.11: never inferred from other lines)
  function giftFree(items, g) {
    var unit = Number(g.original_line_price || 0) / Math.max(1, Number(g.quantity || 1));
    return unit > 0 && Number(g.original_line_price || 0) - Number(g.final_line_price || 0) >= unit;
  }
  // Ran 04.11 (review of an unpublished theme only, never the live theme): before the automatic discount starts the gift
  // line is charged, which would switch the gift off for the session; in an unpublished preview, and only until the
  // discount starts (5.11 00:00 Israel), it counts as free so the popup and the bar's gift stop can be reviewed. From 5.11
  // the real price check applies everywhere again, so a failing discount is never masked (Codex 04.11).
  var REVIEW_UNTIL = 1793829600000; // 2026-11-05T00:00:00+02:00
  var UNPUB = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'unpublished');
  var CLOCK = Math.max(0, (C.serverNow || 0) - Date.now());
  // checked each time: a tab left open past the cutoff goes back to the real price check (Codex 04.11)
  function preview() { return UNPUB && Date.now() + CLOCK < REVIEW_UNTIL; }
  function shownFree(items, g) { return preview() || giftFree(items, g); }
  // review mode: the gift line (snippets/pm-gwp-line.liquid, server-rendered with the real ₪39) looks as it will once the
  // discount runs: "חינם" with the value struck; re-applied whenever the drawer or /cart re-renders the line
  if (preview() && window.MutationObserver) {
    var freeLook = function () {
      if (!preview()) return;
      document.querySelectorAll('[data-pm-gwp-line]:not(.is-free)').forEach(function (l) {
        var pr = l.querySelector('.pm-gwpl__price');
        if (!pr || pr.querySelector('b')) return;
        pr.innerHTML = '<b>חינם</b> <s>' + pr.textContent.trim() + '</s>';
        l.classList.add('is-free');
      });
    };
    new MutationObserver(freeLook).observe(document.documentElement, { childList: true, subtree: true });
    freeLook();
  }
  // a customer already buying the vase herself: the one-per-order discount frees one of her own units, so no extra line
  function ownLines(items) { return items.filter(function (i) { return isProduct(i) && !isGift(i); }); }
  var SKEW = Math.max(0, (C.serverNow || 0) - Date.now());
  if (C.cleanup) C.end = 0; // outside the window: never add, always remove
  var KEY_OUT = 'pm_gwp_unavailable', KEY_DECLINED = 'pm_gwp_declined', KEY_COLOR = 'pm_gwp_color';
  var AVAIL = (C.available || [C.variant]).map(Number);
  var busy = false, failedUntil = 0, seen = false, timer, reloadOnClose = false;
  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v || '1'); } catch (e) {} },
    raw: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  };
  var KEY_PARTY = 'pm_gwp_party', partied = false; // in-memory too: blocked sessionStorage never repeats it on this page
  /* the celebration sheet: built once, closed by its buttons, Escape or a tap outside; confetti only without
     prefers-reduced-motion; focus goes to the sheet and back where it was */
  function celebrate(line) {
    if (document.querySelector('.pm-gwpp')) return;
    var back = document.activeElement;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var w = document.createElement('div');
    w.className = 'pm-gwpp';
    w.setAttribute('dir', 'rtl');
    var conf = '';
    if (!reduce) {
      var cols = ['#d2ad84', '#c9a27a', '#e8d7bf', '#6b1f2a', '#a0522d', '#b5873a', '#8a5a3c'];
      for (var i = 0; i < 40; i++) {
        var leaf = i % 3 === 0, c = cols[i % cols.length];
        var shape = leaf
          ? '<svg viewBox="0 0 20 30"><path d="M10 1C3 9 3 21 10 29 17 21 17 9 10 1Z" fill="' + c + '"/><path d="M10 3v25" stroke="rgba(61,46,32,.35)" stroke-width="1"/></svg>'
          : '<svg viewBox="0 0 20 52"><path d="M10 51V22" stroke="#a8825a" stroke-width="1.2"/><path d="M10 1C17 7 19 16 15 24 13 27 11 28 10 29 9 28 7 27 5 24 1 16 3 7 10 1Z" fill="' + c + '" opacity=".92"/><path d="M10 4v24M10 8l4 5M10 8l-4 5M10 14l5 5M10 14l-5 5M10 20l4 4M10 20l-4 4" stroke="rgba(255,255,255,.55)" stroke-width=".7" fill="none"/></svg>';
        conf += '<i style="--x:' + Math.round(Math.random() * 100) + '%;--d:' + (Math.random() * .6).toFixed(2) + 's;--t:' + (1.8 + Math.random() * 1.4).toFixed(2) + 's;--r:' + Math.round(Math.random() * 540 - 270) + 'deg;--s:' + (1.1 + Math.random() * 0.9).toFixed(2) + '">' + shape + '</i>';
      }
    }
    var name = String(C.name || '').replace(/[<>&"]/g, '');
    // "בוואזה": the Hebrew ב before a single-vav word doubles the vav (Ran's design 03.11)
    var inName = /^ו[^ו]/.test(name) ? 'בו' + name : 'ב' + name;
    var thr = Math.round(Number(C.threshold || 25000) / 100);
    w.innerHTML = '<div class="pm-gwpp__fx" aria-hidden="true">' + conf + '</div>' +
      '<div class="pm-gwpp__card" role="dialog" aria-modal="true" aria-labelledby="pmGwppT" tabindex="-1">' +
      '<button type="button" class="pm-gwpp__close" aria-label="סגירה"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>' +
      '<span class="pm-gwpp__hero">' + '<svg class="pm-gwpp__rib pm-gwpp__rib--r" viewBox="0 0 60 90" aria-hidden="true"><path d="M50 6c-22 6-6 22-26 30S30 62 12 70" fill="none" stroke="#721526" stroke-width="5" stroke-linecap="round"/><path d="M56 22c-16 4-4 16-18 22s4 18-12 26" fill="none" stroke="#d9be9c" stroke-width="3.4" stroke-linecap="round"/><circle cx="10" cy="14" r="3" fill="#d9be9c"/><circle cx="44" cy="80" r="2.6" fill="#721526"/><path d="M22 6l1.2 2.8 2.8 1.2-2.8 1.2L22 14l-1.2-2.8L18 10l2.8-1.2z" fill="#c9a27a"/></svg>' + (C.icon ? '<img class="pm-gwpp__ic" src="' + String(C.icon).replace(/"/g, '') + '" alt="" width="180" height="180">' : '') + '<svg class="pm-gwpp__rib pm-gwpp__rib--l" viewBox="0 0 60 90" aria-hidden="true"><path d="M50 6c-22 6-6 22-26 30S30 62 12 70" fill="none" stroke="#721526" stroke-width="5" stroke-linecap="round"/><path d="M56 22c-16 4-4 16-18 22s4 18-12 26" fill="none" stroke="#d9be9c" stroke-width="3.4" stroke-linecap="round"/><circle cx="10" cy="14" r="3" fill="#d9be9c"/><circle cx="44" cy="80" r="2.6" fill="#721526"/><path d="M22 6l1.2 2.8 2.8 1.2-2.8 1.2L22 14l-1.2-2.8L18 10l2.8-1.2z" fill="#c9a27a"/></svg>' + '</span>' +
      '<b class="pm-gwpp__t" id="pmGwppT">איזה כיף, מגיעה לכם <span class="pm-gwpp__hl">מתנה!</span></b>' +
      '<p class="pm-gwpp__p">העגלה שלכם עברה את ₪' + thr + ', ופינקנו אתכם ' + inName + ' במתנה.</p>' +
      '<div class="pm-gwpp__pick"><span class="pm-gwpp__ph"><span class="pm-gwpp__img"></span><span class="pm-gwpp__nm">' + name + '</span></span><span class="pm-gwpp__q">בחרו צבע</span><div class="pm-gwpp__sw" role="group" aria-label="צבע המתנה"></div><span class="pm-gwpp__cl" aria-live="polite"></span></div>' +
      '<div class="pm-gwpp__b"><button type="button" class="pm-gwpp__x">הוסיפו את המתנה לעגלה</button><span class="pm-gwpp__free"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C9.5 3 12 8 12 8s2.5-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>ללא עלות נוספת</span></div></div>';
    document.body.appendChild(w);
    var card = w.querySelector('.pm-gwpp__card');
    // the quick picker: the vase in the chosen colour and one swatch per colour (a sold-out colour is disabled)
    var OPTS = (C.options || []).filter(function (o) { return IDS.indexOf(Number(o.id)) !== -1; });
    var cur = { key: line.key, id: Number(line.variant_id) }, changed = false, pending = false, closed = false;
    var HEX = function (t) { t = String(t || '').toLowerCase(); return /כחול|blue/.test(t) ? '#5d7fa3' : /זית|olive|ירוק/.test(t) ? '#7d7a4f' : /חום|brown/.test(t) ? '#8a5a3c' : '#b9a58f'; };
    var sw = w.querySelector('.pm-gwpp__sw'), img = w.querySelector('.pm-gwpp__img'), cl = w.querySelector('.pm-gwpp__cl');
    function paint() {
      var o = OPTS.filter(function (x) { return Number(x.id) === cur.id; })[0] || {};
      img.innerHTML = o.image ? '<img src="' + String(o.image).replace(/"/g, '') + '" alt="" width="180" height="180">' : '';
      cl.textContent = o.title ? 'צבע נבחר: ' + o.title : '';
      [].forEach.call(sw.children, function (b) { b.setAttribute('aria-pressed', Number(b.getAttribute('data-id')) === cur.id ? 'true' : 'false'); });
    }
    OPTS.forEach(function (o) {
      var b = document.createElement('button'), ok = o.available && AVAIL.indexOf(Number(o.id)) !== -1;
      b.type = 'button'; b.className = 'pm-gwpp__s'; b.setAttribute('data-id', o.id);
      b.setAttribute('aria-label', o.title + (ok ? '' : ' (אזל)'));
      b.disabled = !ok;
      b.style.setProperty('--c', HEX(o.title));
      b.appendChild(document.createElement('i'));
      b.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4 8-9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      b.addEventListener('click', function () {
        var id = Number(o.id);
        if (id === cur.id || busy) return;
        card.classList.add('is-busy');
        pending = true;
        swapTo(id, cur.key, true).then(function (cart) {
          var g = (cart.items || []).filter(function (i) { return Number(i.variant_id) === id; })[0];
          cur = { key: g ? g.key : cur.key, id: id }; changed = true;
          card.classList.remove('is-busy'); paint();
        }).catch(function () {
          // a failed or half-done swap: read the real cart before the next choice; the picker shows the colour that is
          // really there, and an extra gift line is cleaned by the reconciliation (keeping the chosen colour)
          changed = true;
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c2) {
            var gs = (c2.items || []).filter(isGift);
            var keepL = gs.filter(function (i) { return Number(i.variant_id) === wanted(); })[0] || gs[0];
            if (keepL) cur = { key: keepL.key, id: Number(keepL.variant_id) };
            if (gs.length > 1) refresh();
          }).catch(function () {}).then(function () { card.classList.remove('is-busy'); b.disabled = AVAIL.indexOf(id) === -1; paint(); });
        })
          .then(function () { pending = false; if (closed) { rebuild(); schedule(400); } }); // closed meanwhile: refresh now
      });
      sw.appendChild(b);
    });
    if (!OPTS.length) w.querySelector('.pm-gwpp__pick').remove();
    paint();
    function close() { document.removeEventListener('focusin', keep); document.documentElement.classList.remove('pm-gwpp-open'); closed = true; if (changed && !pending) { rebuild(); schedule(400); } w.classList.add('is-out'); setTimeout(function () { w.remove(); }, 260); if (back && back.focus) back.focus(); }
    // a real modal: Tab and Shift+Tab stay inside the card's buttons. Escape reaches this sheet through the shared
    // layer guard (snippets/pampas-layer-guard.liquid: html.pm-gwpp-open, the top layer), so one Escape closes only it
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(w.querySelectorAll('button'), function (x) { return !x.disabled; }), first = f[0], last = f[f.length - 1];
      if (document.activeElement === card) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    w.addEventListener('keydown', onKey);
    function keep(e) { if (!w.contains(e.target)) w.querySelector('.pm-gwpp__x').focus(); } // focus that escapes comes back
    document.addEventListener('focusin', keep);
    document.documentElement.classList.add('pm-gwpp-open');
    w.addEventListener('click', function (e) { if (e.target === w || e.target.classList.contains('pm-gwpp__fx')) close(); });
    w.querySelector('.pm-gwpp__x').addEventListener('click', close);
    w.querySelector('.pm-gwpp__close').addEventListener('click', close);
    // the sheet's clicks never reach the drawer's outside-click handler (it would close the drawer); the drawer opens
    // after this click is done
    w.addEventListener('click', function (e) { e.stopPropagation(); });
    requestAnimationFrame(function () { w.classList.add('is-in'); card.focus(); });
  }
  function wanted() { var c = Number(ss.raw(KEY_COLOR)); return AVAIL.indexOf(c) !== -1 ? c : Number(C.variant); }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function live() { return Date.now() + SKEW < C.end && !ss.get(KEY_OUT); }
  // the gift became unavailable in this session (charged = no discount, sold out): every gift text on the page hides
  // (html.pm-gwp-off; CSS in snippets/pm-gwp-nudge.liquid and assets/pm-campaign.css)
  function offMark() {
    if (!ss.get(KEY_OUT)) return;
    document.documentElement.classList.add('pm-gwp-off');
    // the strip's label for screen readers drops its gift clause too
    if (document.querySelectorAll) document.querySelectorAll('.pmc-strip[aria-label]').forEach(function (a) { a.setAttribute('aria-label', a.getAttribute('aria-label').replace(/, ומתנה בקנייה מעל ₪\d+/, '')); });
  }
  offMark();
  function publish(state) {
    offMark();
    window.PMGWPState = state;
    document.dispatchEvent(new CustomEvent('pm:gwp', { detail: state }));
  }
  function rebuild() {
    if (document.body.classList.contains('template-cart')) {
      // the gift popup stays open while the colour changes; the page refreshes when it closes (Codex 04.11)
      var gs = document.querySelector('[data-pm-gcs]');
      if (gs && gs.open) { reloadOnClose = true; return; }
      setTimeout(function () { location.reload(); }, 300);
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) { var e = new Error(path); e.status = r.status; throw e; } return r.json(); });
  }
  function reconcile(cart) {
    var items = cart.items || [];
    var gifts = items.filter(isGift);
    var eligible = items.reduce(function (s, i) { return s + (isProduct(i) ? 0 : Number(i.original_line_price || 0)); }, 0);
    var on = live() && !ss.get(KEY_DECLINED);
    var failing = Date.now() < failedUntil;
    var job = null, ownVase = false;
    if (!on || eligible < C.threshold) {
      if (gifts.length) job = function () { return post('cart/change.js', { id: gifts[0].key, quantity: 0 }); };
    } else if (gifts.length) {
      if (busy) {
        // a colour swap is in flight (two gift lines for a moment, one of them charged by the one-per-order discount):
        // judge nothing until it settles
      } else if (gifts.length > 1) {
        // first one line only (Codex 03.11: with two lines the discount frees one, so "charged" is not a failure yet);
        // one extra line per pass, the customer's chosen colour is the one that stays (a half-done colour swap)
        var extra = gifts.filter(function (i) { return Number(i.variant_id) !== wanted(); })[0] || gifts[gifts.length - 1];
        job = function () { return post('cart/change.js', { id: extra.key, quantity: 0 }); };
      } else if (ownLines(items).length) {
        // her own vase gets the discount: the extra gift line goes (not a failure, the gift stays on for the session)
        // and the removal is ours, so it is never read as her declining it: the gift returns if she takes the vase out (Codex 04.11)
        ownVase = true;
        job = function () { return post('cart/change.js', { id: gifts[0].key, quantity: 0 }); };
      } else if (!shownFree(items, gifts[0])) {
        ss.set(KEY_OUT); // the one gift line is charged: the discount is missing; never promise a gift that costs money
        job = function () { return post('cart/change.js', { id: gifts[0].key, quantity: 0 }); };
      } else if (gifts[0].quantity > 1) {
        job = function () { return post('cart/change.js', { id: gifts[0].key, quantity: 1 }); };
      }
    } else if (seen && !busy) {
      ss.set(KEY_DECLINED); // the gift was in this cart and the customer took it out
      on = false;
    } else if (!failing && !ownLines(items).length) {
      job = function () { return post('cart/add.js', { items: [{ id: wanted(), quantity: 1, properties: { _gwp: '1' } }] }); };
    }
    seen = !ownVase && gifts.length > 0 && on && eligible >= C.threshold;
    // Ran 03.11: the first time a free gift sits in the cart this session, a short celebration (pampas and dried leaves)
    if (!job && on && gifts.length === 1 && shownFree(items, gifts[0]) && !partied && !ss.get(KEY_PARTY)) { partied = true; ss.set(KEY_PARTY); try { celebrate(gifts[0]); } catch (e) { console.warn('pm-gwp party', e && e.message); } }
    var giftLine = gifts.length === 1 && shownFree(items, gifts[0]) ? gifts[0] : null;
    publish({ active: on && !failing && !ss.get(KEY_OUT), threshold: C.threshold, eligible: eligible, giftKey: giftLine && !job ? giftLine.key : null, giftVariant: giftLine && !job ? Number(giftLine.variant_id) : null });
    if (!job || busy) return;
    busy = true;
    cartEpoch++;
    job().then(function () { busy = false; cartEpoch++; failedUntil = 0; rebuild(); schedule(400); })
      .catch(function (e) {
        busy = false;
        cartEpoch++;
        if (e.status === 422) ss.set(KEY_OUT); else failedUntil = Date.now() + 60000;
        console.warn('pm-gwp', e.status || e.message);
        refresh(); // re-publish without the gift promise
      });
  }
  // an older cart read that answers after a newer one is dropped: it could look like the customer took the gift out (Codex 04.11)
  // so is a read that started before one of the engine's own cart changes finished: the read after that change decides
  var readSeq = 0, readDone = 0, cartEpoch = 0;
  function refresh() {
    var n = ++readSeq, e = cartEpoch;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) { if (n < readDone || e !== cartEpoch) return; readDone = n; reconcile(cart); }).catch(function () {});
  }
  function schedule(d) { clearTimeout(timer); timer = setTimeout(refresh, d || 150); }
  // colour swap: add the new colour first, then remove the old line: a failed add (stock, network) leaves the earned
  // gift as it was and is never read as the customer declining it (Codex adversarial 03.11). Shared by the cart line's
  // swatches and the celebration's quick picker; `later` skips the rebuild (the picker rebuilds when it closes).
  function swapTo(id, oldKey, later) {
    if (AVAIL.indexOf(id) === -1 || busy || C.cleanup) return Promise.reject(new Error('skip'));
    ss.set(KEY_COLOR, String(id));
    busy = true;
    cartEpoch++;
    var added = false;
    return post('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _gwp: '1' } }] })
      .then(function () { added = true; return post('cart/change.js', { id: oldKey, quantity: 0 }); })
      .then(function (cart) { busy = false; cartEpoch++; if (!later) { rebuild(); schedule(400); } return cart; })
      .catch(function (err) {
        busy = false;
        cartEpoch++;
        // only a refused ADD means this colour is out; a failed removal of the old line (stale key) keeps the choice,
        // and the reconciliation removes the old line, keeping the chosen colour
        if (!added && err.status === 422) { AVAIL = AVAIL.filter(function (v) { return v !== id; }); ss.set(KEY_COLOR, String(C.variant)); }
        if (added) schedule(200);
        console.warn('pm-gwp colour', err.status || err.message);
        if (!later) { rebuild(); schedule(400); }
        throw err;
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pm-gwp-color]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var id = Number(b.getAttribute('data-pm-gwp-color'));
    var line = b.closest('[data-pm-gwp-line]');
    if (!line || b.getAttribute('aria-pressed') === 'true') { if (AVAIL.indexOf(id) !== -1) ss.set(KEY_COLOR, String(id)); return; }
    line.classList.add('is-busy');
    swapTo(id, line.getAttribute('data-key')).catch(function () { line.classList.remove('is-busy'); });
  });
  // cart nudge (snippets/pm-gwp-nudge.liquid): add a one-variant product, then the drawer rebuilds
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pm-gwp-add]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('is-busy');
    post('cart/add.js', { items: [{ id: Number(b.getAttribute('data-pm-gwp-add')), quantity: 1 }] })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:updated')); rebuild(); schedule(400); })
      .catch(function (err) { b.classList.remove('is-busy'); console.warn('pm-gwp nudge', err.status || err.message); });
  });
  /* the gift details sheet of the sale page (snippets/pm-gift-card.liquid, Ran 04.11). A colour chosen here is the colour
     the gift arrives in; with the gift already in the cart it swaps that line, as the cart's own swatches do. */
  function initDetails() {
    var d = document.querySelector('[data-pm-gcs]');
    if (!d || !d.showModal) return;
    var sw = [].slice.call(d.querySelectorAll('[data-pm-gcs-s]'));
    var photo = d.querySelector('[data-pm-gcs-photo]'), label = d.querySelector('[data-pm-gcs-color]'), thumb = document.querySelector('[data-pm-gcs-thumb]');
    var html = document.documentElement, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var key = null, cur = 0, inCart = false, pick = 0, fromCart = false;
    function btn(id) { return sw.filter(function (b) { return Number(b.getAttribute('data-pm-gcs-s')) === id; })[0]; }
    function sync() {
      var st = window.PMGWPState || {};
      key = st.giftKey || null; inCart = !!key;
      cur = st.giftVariant || wanted();
      if (!btn(cur) || btn(cur).disabled) cur = Number(C.variant);
    }
    function paint() {
      var b = btn(cur);
      if (b) {
        if (d.open && photo.getAttribute('src') !== b.getAttribute('data-img')) photo.src = b.getAttribute('data-img');
        if (thumb) thumb.src = b.getAttribute('data-thumb');
        label.textContent = b.getAttribute('data-title');
      }
      sw.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      d.querySelectorAll('[data-pm-gcs-out]').forEach(function (e) { e.hidden = inCart; });
      d.querySelectorAll('[data-pm-gcs-in]').forEach(function (e) { e.hidden = !inCart; });
    }
    function close(then) {
      if (!d.open) return;
      var done = function () {
        d.classList.remove('is-closing'); d.close(); html.classList.remove('pm-gcs-open');
        if (reloadOnClose) { location.reload(); return; }
        // a colour change re-renders the line that opened the popup: focus goes back to the new one (Codex 04.11)
        if (fromCart) { var o = document.querySelector('[data-pm-gwp-line] [data-pm-gcs-open]'); if (o) o.focus({ preventScroll: true }); }
        if (then) then();
      };
      if (reduce) { done(); return; }
      d.classList.add('is-closing');
      setTimeout(done, 200);
    }
    // the gift card, the voucher and the cart's gift line; the cart line is re-rendered, so by delegation
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-pm-gcs-open]');
      if (!o || d.open || (window.PMGWPState || {}).active === false) return;
      fromCart = !!o.closest('[data-pm-gwp-line]');
      sync();
      d.showModal();
      html.classList.add('pm-gcs-open');
      paint();
    });
    // the theme's Tab trap for the drawer and its search's Escape listen on the page; clicks and the key's release are kept
    // from the drawer by snippets/pampas-layer-guard.liquid
    d.addEventListener('keydown', function (e) { e.stopPropagation(); });
    d.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.querySelector('[data-pm-gcs-close]').addEventListener('click', function () { close(); });
    d.querySelector('[data-pm-gcs-cta]').addEventListener('click', function () {
      var wasIn = inCart, back = fromCart;
      close(function () {
        if (back) return; // opened from the cart: it is right there underneath
        if (wasIn) { document.dispatchEvent(new CustomEvent('cart:open')); return; }
        var g = document.querySelector('.pmc-grid'), h = document.getElementById('SiteHeader');
        if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - (h ? h.getBoundingClientRect().bottom : 0) - 12, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    sw.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = Number(b.getAttribute('data-pm-gcs-s'));
        if (b.disabled || id === cur || d.classList.contains('is-busy') || !live()) return;
        // no line yet: the engine adds this colour; `pick` covers an add already on its way with the previous colour
        if (!key) { ss.set(KEY_COLOR, String(id)); cur = id; pick = id; paint(); return; }
        d.classList.add('is-busy');
        swapTo(id, key).then(function (cart) {
          var line = (cart.items || []).filter(function (i) { return Number(i.variant_id) === id && isGift(i); })[0];
          if (line) { key = line.key; cur = id; }
        }).catch(function () {}).then(function () { d.classList.remove('is-busy'); paint(); });
      });
    });
    // the card shows the colour that was chosen, also after the cart changes or the page reloads
    document.addEventListener('pm:gwp', function () {
      var st = window.PMGWPState || {};
      // the gift is off, gone or declined: no sheet and no card promising it
      document.querySelectorAll('.pmc-gift-row, .pmc-card__gw').forEach(function (r) { r.style.display = st.active === false ? 'none' : ''; });
      if (st.active === false) { pick = 0; close(); return; }
      if (d.classList.contains('is-busy')) return;
      if (pick && st.giftKey) {
        if (st.giftVariant !== pick) {
          if (busy) return;
          var id = pick;
          pick = 0;
          d.classList.add('is-busy');
          swapTo(id, st.giftKey).catch(function () {}).then(function () { d.classList.remove('is-busy'); });
          return;
        }
        pick = 0;
      }
      sync();
      paint();
    });
    sync();
    paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDetails); else initDetails();
  ['cart:updated', 'ajaxProduct:added', 'cart:build'].forEach(function (n) { document.addEventListener(n, function () { schedule(); }); });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('#CartDrawer, #CartPageForm')) schedule(1250); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.js-qty__adjust, .cart__remove, .cart__remove-button, .add-to-cart, [name="add"]')) schedule(900); });
  // window end: every gift text on the page hides (html.pm-gwp-off) and the gift line is removed
  // (setTimeout caps at ~24.8 days: a firing before the end re-arms for the rest)
  function atEnd() {
    var left = C.end - Date.now() - SKEW;
    if (left > 0) { setTimeout(atEnd, Math.min(left + 500, 2147483000)); return; }
    document.documentElement.classList.add('pm-gwp-off');
    refresh();
  }
  if (Date.now() + SKEW < C.end) atEnd();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
